<template>
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 19 29"
    fill="currentColor"
  >
    <path
      d="M4.2,28.7c-.7,0-1.5,0-2.2-.1-.7,0-1.3-.2-2-.4v-1.3c2.3,0,4.4-.5,6.1-1.5,1.8-1,3.1-2.4,4.1-4.2,1-1.8,1.4-3.9,1.4-6.3s-.5-4.5-1.4-6.3c-1-1.8-2.3-3.2-4-4.2C4.5,3.3,2.4,2.8,0,2.8v-1.3c1.2-.3,2.6-.5,4.1-.5s4,.3,5.7,1c1.8.7,3.3,1.6,4.5,2.8,1.3,1.2,2.3,2.7,3,4.4.7,1.7,1,3.6,1,5.7s-.6,5.1-1.8,7.2c-1.2,2.1-2.9,3.7-5,4.9-2.1,1.2-4.6,1.8-7.4,1.8ZM4.2,27.5c1.8,0,3.4-.3,4.9-1,1.5-.7,2.8-1.6,4-2.7,1.1-1.2,2-2.5,2.6-4,.6-1.5,1-3.2,1-4.9s-.3-3.4-1-4.9c-.6-1.5-1.5-2.9-2.6-4-1.1-1.2-2.4-2.1-4-2.7-1.5-.7-3.2-1-4.9-1,1.9.4,3.5,1.2,4.9,2.4,1.4,1.2,2.5,2.7,3.2,4.4.8,1.8,1.2,3.7,1.2,5.8s-.4,4-1.2,5.8c-.7,1.8-1.8,3.2-3.2,4.4-1.4,1.2-3,2-4.9,2.4Z"
    />
  </svg>
</template>
